module.exports = __webpack_public_path__ + "img/fitness-coach.3be46b22.webp";